export default __webpack_public_path__ + "static/media/south_ossetia.a2fdad2c.svg";